import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './modules/alert.module'
import { auth } from './modules/auth.module'
import { init } from './modules/init.module'
import { modal } from './modules/modal.module'
import { layoutevents } from './modules/layoutevents.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    auth,
    init,
    layoutevents,
    modal
  }
})
